import React, { Component } from 'react';

class Loadingsvg extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <img
        src={`/svg/${this.props.name || 'puff'}.svg`}
        width={this.props.size || 30}
        alt="svg :)"
        style={{ fill: this.props.color || 'white', display: this.props.hidden ? 'none' : 'inline-block' }}
      />
    );
  }
}

export default Loadingsvg;
